import React from 'react'
import Link from 'gatsby-link'

const HeaderRainbow = () =>
  <div className='header-diagonal rainbow'>
  </div>

export default HeaderRainbow



// WEBPACK FOOTER //
// ./src/components/HeaderRainbow.js